import { request } from "src/api/api-client";
import type { CustomerResponse, UpdateResponse } from "src/api/types/responses";
import { AuthorisationFormValues } from "src/types/form-data";
import { CustomerRequest, UpdateRequest } from "src/api/types/requests";

const mapCustomerLookupFormData = (formData: AuthorisationFormValues): CustomerRequest => {
  const reference = formData.referenceNumber.trim();

  return {
    reference,
    dob: `${formData.dobDay}/${formData.dobMonth}/${formData.dobYear}`,
  };
};

export async function fetchCustomerDetails(formData: AuthorisationFormValues): Promise<CustomerResponse> {
  return request<CustomerResponse, CustomerRequest>({
    url: `${import.meta.env.VITE_FCE_MFC_CUSTOMER_SERVICE_URL_V1}/fetchCustomerDetails`,
    method: "POST",
    body: mapCustomerLookupFormData(formData),
  });
}

export async function updateCustomerDetails(formData: UpdateRequest): Promise<CustomerResponse> {
  return request<CustomerResponse, UpdateRequest>({
    url: `${import.meta.env.VITE_FCE_MFC_CUSTOMER_SERVICE_URL_V1}/updateCustomerDetails`,
    method: "POST",
    body: formData,
  });
}
